type RiskLevel = 'low' | 'medium' | 'high';
type LoadTrend = 'stable' | 'increasing' | 'decreasing';

export function getAdherenceVariant(pct: number): 'success' | 'warning' | 'danger' {
  if (pct >= 80) return 'success';
  if (pct >= 60) return 'warning';
  return 'danger';
}

export function getLoadTrendDisplay(trend: LoadTrend): { value: string } {
  switch (trend) {
    case 'increasing':
      return { value: '↗ Increasing' };
    case 'decreasing':
      return { value: '↘ Decreasing' };
    default:
      return { value: '→ Stable' };
  }
}

export function getRiskVariant(level: RiskLevel): 'success' | 'warning' | 'danger' {
  switch (level) {
    case 'low':
      return 'success';
    case 'medium':
      return 'warning';
    case 'high':
      return 'danger';
  }
}

export function getAvatarInitials(athlete: { name: string; avatar_initials?: string } | null): string {
  if (!athlete) return '';
  if (athlete.avatar_initials) {
    return athlete.avatar_initials;
  }
  return athlete.name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);
}
